// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"671201f8","455":"6a6ab071","977":"e602d54f"}[chunkId] + ".chunk.js";
};